import React, { useState } from 'react';
import { FiX } from 'react-icons/fi';
import {
  NEWS_TAG_BINDINGS,
  emptyEntityFilters,
} from '../utilities/adminSearch';
import { useI18n } from '../utilities/i18n';
import AdminSearchPicker from './AdminSearchPicker';

export default function NewsEntityFilters({
  value,
  onChange,
  disabled,
  hint,
}) {
  const { t } = useI18n();
  const filters = value || emptyEntityFilters();
  const [activeType, setActiveType] = useState('');

  const spec = NEWS_TAG_BINDINGS.find((item) => item.type === activeType);

  const setFilter = (type, nextValue) => {
    onChange({
      ...filters,
      [type]: nextValue,
    });
  };

  const chips = NEWS_TAG_BINDINGS.reduce((list, { type, labelKey }) => {
    const item = filters[type];
    if (!item?.id) return list;
    list.push({
      key: type,
      label: `${t(labelKey)}: ${item.name || `#${item.id}`}`,
      onRemove: () => setFilter(type, null),
    });
    return list;
  }, []);

  return (
    <div className={`news-entity-filters ${disabled ? 'is-disabled' : ''}`}>
      <div className="news-filter-add">
        <select
          className="st-select news-filter-type"
          value={activeType}
          disabled={disabled}
          onChange={(event) => setActiveType(event.target.value)}
        >
          <option value="">{t('searchAddFilter')}</option>
          {NEWS_TAG_BINDINGS.map((item) => (
            <option key={item.type} value={item.type}>{t(item.labelKey)}</option>
          ))}
        </select>

        {spec ? (
          <AdminSearchPicker
            type={spec.type}
            disabled={disabled}
            placeholder={t('searchEntityPh')}
            onPick={(item) => {
              setFilter(spec.type, item);
              setActiveType('');
            }}
          />
        ) : null}
      </div>

      {hint ? <div className="news-filter-hint">{hint}</div> : null}

      {chips.length ? (
        <div className="news-tag-chips">
          {chips.map((chip) => (
            <span key={chip.key} className="usr-chip news-tag-chip">
              {chip.label}
              {!disabled ? (
                <button
                  type="button"
                  className="news-tag-remove"
                  onClick={chip.onRemove}
                  aria-label={t('searchRemoveFilter', { label: chip.label })}
                >
                  <FiX />
                </button>
              ) : null}
            </span>
          ))}
        </div>
      ) : null}
    </div>
  );
}
